import { type Event } from 'hb-react/shared/apps/Events';
import { ZoomMeetingEarlyAccessMinutes } from 'hb-react/shared/apps/Zoom/constants';
import dayjs from 'hb-react/shared/utils/dayjs/dayjs';
import { type User } from 'hb-react/types';

export const userAllowedToJoin = (
  event: Event,
  currentUser: User | null,
  flagEvStandaloneZoom: boolean,
) => {
  const isFeatureEnabled = flagEvStandaloneZoom;

  const userIsLoggedIn = !!currentUser;

  const eventIsInternalZoomMeeting = event.is_internal_zoom_meeting;

  const eventIsStartedOrStartingSoon = dayjs(event.start_date).isBefore(
    dayjs().add(ZoomMeetingEarlyAccessMinutes, 'minutes'),
  );

  const userHasTicketIfRequired =
    event.participation_type !== 'tickets' || event.has_a_ticket;

  const userHasRsvpIfRequired =
    event.participation_type !== 'rsvp' ||
    ['maybe_attend', 'attend'].includes(event.response_type);

  return [
    isFeatureEnabled,
    userIsLoggedIn,
    eventIsInternalZoomMeeting,
    eventIsStartedOrStartingSoon,
    userHasTicketIfRequired,
    userHasRsvpIfRequired,
  ].every(Boolean);
};
